import { PosIconProps, SvgWrapper } from 'src/svgs/SvgWrapper';

export function ChevronStartIconV2(props: PosIconProps) {
  return (
    <SvgWrapper
      aria-label="ChevronEndIcon"
      fill="currentColor"
      style={{ transform: 'scaleX(-1)' }}
      viewBox="8 6 8 12"
      {...props}
    >
      <path
        d="M8.75 16.75L13.25 11.75L8.75 6.75"
        stroke="currentColor"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M15.5 7V17"
        stroke="currentColor"
        strokeLinecap="round"
        fill="none"
      />
    </SvgWrapper>
  );
}
